import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import type { ApiTypes } from '@hyundai/ng-common-lib';

@Component({
    selector: 'ui-opening-range',
    standalone: true,
    imports: [],
    templateUrl: './opening-range.component.html',
    styleUrl: './opening-range.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpeningRangeComponent {
    openingRange = input.required<ApiTypes.DealerOpeningRange[]>();
}
